import { ApplicationRef, inject, Injectable, OnDestroy } from '@angular/core';
import { VersionReadyEvent, SwUpdate } from '@angular/service-worker';
import { concat, interval, Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { MessagingService } from '../components/messaging/messaging.service';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService implements OnDestroy {
  appRef = inject(ApplicationRef);
  #serviceWorkerUpdate = inject(SwUpdate);
  #message = inject(MessagingService);

  swSubscription: Subscription;

  constructor() {
    if (this.#serviceWorkerUpdate.isEnabled) {
      const appIsStable = this.appRef.isStable.pipe(first((isStable) => isStable === true));
      const timeInterval = interval(1000 * 60 * 60 * 2);

      concat(appIsStable, timeInterval).subscribe(() => this.#serviceWorkerUpdate.checkForUpdate());
    }
  }

  checkForUpdates(): void {
    this.swSubscription = this.#serviceWorkerUpdate.versionUpdates
      .pipe(filter((event: VersionReadyEvent) => event.type === 'VERSION_READY'))
      .subscribe({
        next: async () => {
          try {
            await this.#serviceWorkerUpdate.activateUpdate();
            document.location.reload();
          } catch (error) {
            console.error(`Service Worker activation error: ${error}`);
            this.#message.error(
              'The update could not be applied. Please refresh the page manually to get the latest version.'
            );
          }
        },
        error: (error) => console.error(`Service Worker update error: ${error}`)
      });
  }

  ngOnDestroy() {
    this.swSubscription.unsubscribe();
  }
}
